import React from "react";
import styled from "styled-components";

import { InfiniteScrollBoxProps } from "./types";

export function isInViewport(el: HTMLDivElement | null, parentEl: HTMLDivElement | null, horizontal: boolean) {
  if (!el || !parentEl) {
    return false;
  }
  const rect = el?.getBoundingClientRect();
  const parentRect = parentEl.getBoundingClientRect();
  if (horizontal) {
    return rect.left <= parentRect.right - rect.width / 2;
  }
  return rect.bottom <= parentRect.bottom + rect.width / 2;
}

type IInfiniteBoxProps = InfiniteScrollBoxProps & React.HTMLAttributes<HTMLDivElement>;

export const InfiniteBox = styled(
  React.forwardRef<HTMLDivElement, IInfiniteBoxProps>(
    ({ horizontal, wrap, ...props }: IInfiniteBoxProps, ref) => <div ref={ref} {...props} />
  )
)`
  display: flex;
  flex-direction: ${props => (props.horizontal ? "row" : "column")};
  flex-wrap: ${props => (props.wrap ? "wrap" : "nowrap")};

  gap: ${({ gap, wrap }) => (wrap ? 0 : gap)};
  height: ${props => props.height};

  overflow-x: ${({ horizontal, wrap }) => (horizontal && !wrap ? "auto" : "hidden")};
  overflow-y: ${({ horizontal, wrap }) => (!horizontal || wrap ? "auto" : "hidden")};

  transition: all ease-in-out 2s;
  width: ${props => props.width};
`;
